/**
 * Model class for help messages
 */

import { required } from 'vuelidate/lib/validators'

export default {
    fields: {
        id: {
            type: Number,
            showIf (model) {
                return false
            },
        },
        route: {
            label: 'Route',
            type: 'text',
            validations: {
                required,
                route_unique: async function (value) {        //  do NOT convert to (value)=> format
                    if (value) {
                        let filters = {
                            route: { field: 'route', value: value }
                        }
                        let intro_id = this.$v.form['id'] ? this.$v.form['id'].$model : null
                        if (intro_id) {
                            filters.id = { field: 'id', value: intro_id, negate: true }
                        }
                        return await this.$api.getItems(this, 'intro', filters, null, [])
                            .then((intros) => {
                                return !intros.length
                            })
                    }
                    return true
                }
            },
            invalidFeedback: {
                required: 'The route is required',
                route_unique: 'This route already exists',
            }
        },
        content: {
            label: 'Content',
            type: 'rich'
        },
    },
}
